import { createContext, type ReactNode, useContext } from 'react';

import { WEB_SOCKET_URL } from 'config';
import { usersApi } from 'services/rtk/users';
import { useWebSocket, type UseWebSocketStatus } from 'services/ws/useWebSocket';

import { parseMessage } from './parseMessage';
import { WSEventBus } from './WSEventBus';

interface WSContextValue {
  send: (data: any) => void;
  status: UseWebSocketStatus;
  bus: WSEventBus<any>;
}

const bus = new WSEventBus();

export const WSContext = createContext<WSContextValue | null>(null);

export const WSProvider = ({ children }: { children: ReactNode }) => {
  const { data: userData } = usersApi.useFetchMeQuery();

  const token = localStorage.getItem('token');

  const ws = useWebSocket(WEB_SOCKET_URL + `?token=${token}`, {
    ready: Boolean(userData),
    retry: 3,
    onMessage: (e) => {
      const msg = parseMessage(e);
      if (!msg) return;

      const { event, ...data } = msg;

      bus?.emit(event, data);
    },
    onReconnect: () => {
      bus?.emit('ws:reconnected', null);
    },
  });

  return (
    <WSContext.Provider
      value={{
        send: ws.sendObj,
        status: ws.status,
        bus,
      }}
    >
      {children}
    </WSContext.Provider>
  );
};

export const useWSContext = () => {
  const value = useContext(WSContext);
  return value as WSContextValue;
};
